module.exports = __webpack_public_path__ + "static/media/Nana-RunningOutofTime.c55d327f.jpg";